import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import DataContext from '../stores/DataContextProvider';
import dataFlow from '../utils/Dataflow.json';
import './Instruction.css';

const Instruction = () => {
  const { levelCode,updateSK, skillCode, instruction, updateInstruction,updateLevel, testCode, updateTestCode,handleBackOneLevel } = useContext(DataContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedOptions } = location.state || {}; 
 
  useEffect(() => {
    const fetchInstructionData = () => {
      let foundInstruction = null;
      const searchInstruction = (items) => {
        if (!Array.isArray(items)) {
          return;
        }
        for (const item of items) {
          if (item.levelCode === levelCode && item.skillCode === skillCode) {
            foundInstruction = item;
            return;
          }
          if (item.item && Array.isArray(item.item)) {
            searchInstruction(item.item);
          }
          if (foundInstruction) return;
        }
      };

      if (Array.isArray(dataFlow.dataFlow)) {
        searchInstruction(dataFlow.dataFlow);
      } else {
        console.error('Invalid dataFlow structure');
      }

      updateInstruction(foundInstruction ? foundInstruction.instruction : null);
      updateTestCode(foundInstruction ? foundInstruction.testCode : 1); 
    };

    fetchInstructionData();
  },[levelCode, skillCode, updateInstruction, updateTestCode]);

  const handleNext = () => {
    switch (testCode) {
      case 1:
        navigate('/testscreen1', { state: { selectedOptions } });
        break;
      case 2:
        navigate('/testscreen2', { state: { selectedOptions } });
        break;
      case 3:
        navigate('/testscreen3', { state: { selectedOptions } });
        break;
      case 4:
        navigate('/testscreen4', { state: { selectedOptions } });
        break;
      case 5:
        navigate('/testscreen5', { state: { selectedOptions } });
        break;
      case 6:
        navigate('/testscreen6', { state: { selectedOptions } });
        break;
      case 7:
        navigate('/testscreen7', { state: { selectedOptions } });
        break;
      case 8:
        navigate('/testscreen8', { state: { selectedOptions } });
        break;
      case 9:
        navigate('/testscreen9', { state: { selectedOptions } });
        break;
      case 10:
        navigate('/testscreen10', { state: { selectedOptions } });
        break;
      case 11:
        navigate('/testscreen11', { state: { selectedOptions } });
        break;
      case 12:
        navigate('/testscreen12', { state: { selectedOptions } });
        break;
      case 13:
        navigate('/testscreen13', { state: { selectedOptions } });
        break;
      case 14:
        navigate('/testscreen14', { state: { selectedOptions } });
        break;
      default:
        console.error('Invalid testCode:', testCode);
        navigate('/home'); // Fallback in case of an invalid testCode
    }
  };

const handleBack = () => {
  if (levelCode) {
    navigate('/level');
  } else {
    handleBackOneLevel();
    updateLevel(3);
     updateSK(''); 
    
    setTimeout(() => navigate('/home'), 0); // Ensure state update before navigation
  }
};
  if (!instruction) {
    return <div>Loading...</div>;
  }

  return (
    <Layout>
      <div className="instruction-container">
        <h1>Instruction</h1>
        <b>{instruction}</b>
        <div className="button-container">
          <button onClick={handleBack}>Back</button>
          <button onClick={handleNext}>Start</button>
        </div>
      </div>
    </Layout>
  );
};

export default Instruction;
